export class BillNumberRequest {
   billNumber:string
   operation?:string
   contractorId ?:number
   fromDate?: string
   toDate?:string
   unitId?:number
   
    constructor(billNumber:string,operation?:string,contractorId ?:number,fromDate?: string,
        toDate?:string,unitId?:number) {
        this.billNumber=billNumber
        this.operation=operation
        this.contractorId = contractorId
        this.fromDate = fromDate
        this.toDate = toDate
        this.unitId=unitId

    }
}
